// La sede en curso: vive en la URL (?sede=), se conserva al navegar (main.tsx, retainSearchParams)
// y solo vale si está entre las sedes que esta persona puede ver. Un id desconocido se ignora:
// nunca se manda al servidor, que respondería 403 o 404.
import { useSearch } from "@tanstack/react-router";
import { useLectura } from "./datos";

export function useSede() {
  const { sede: enUrl } = useSearch({ strict: false }) as { sede?: string };
  const consulta = useLectura("/sedes");
  const sedes = consulta.data?.sedes ?? [];
  const actual = sedes.find((s) => s.id === enUrl);
  return {
    sedes,
    actual,
    // Parámetros para /citas y /hoy: vacíos sin sede elegida.
    params: actual ? { sede: actual.id } : undefined,
    todas: consulta.data?.todas ?? true,
    multi: sedes.length >= 2,
    // Con ?sede= en la URL, esperar la lista antes de leer: si no, se leería dos veces.
    lista: !enUrl || consulta.isFetched,
  };
}
